/**
 * @export
 * @class ContentSwitcher
 */
import { getAll, getParameterByName, insertParam } from '../../helpers/utilities';

export class ContentSwitcher {
    public static selector = '.js-content-switcher';
    private id: string;
    private root: Element;
    private btns: Element[];
    private blocks: Element[];
    

    /**
     * Initialises a new instance of ContentSwitcher.
     * 
     * @param root The containing element for this block.
     */
    constructor(root: Element) {
        this.root   = root;
        this.id     = root.getAttribute('data-id') as string;
        this.blocks = getAll('.js-content-switcher__block', this.root) as Element[];
        this.btns   = getAll('.js-content-switcher__btn', this.root) as Element[];
        this.bindEvents();
    }


    /**
     * Binds the events for this block.
     * 
     * @private
     * @return void
     */
    private bindEvents(): void {

        // Get the active one
        const activeItem = getParameterByName(this.id);
        if(activeItem) {
            const targetBtn = this.btns.filter(btn => btn.getAttribute('data-label') === activeItem);
            if(targetBtn) {
                const targetIndex = parseInt(targetBtn[0].getAttribute('data-index') as string, 10) - 1;
                this.toggle(targetIndex);
            }
        }

        // On button click, change the currently visible block.
        this.btns.forEach(btn => {
            btn.addEventListener('click', () => {
                const index = parseInt(btn.getAttribute('data-index') as string, 10) - 1;
                this.toggle(index);
                
                // Update fullpage
                window.app.modules.home.fullPage.fpInstance.reBuild();
            });
        });
    }


    /**
     * Toggles both the button and block change at once.
     * 
     * @private
     * @return void
     * @param newIndex The index of the block to show.
     */
    private toggle(newIndex: number): void {
        this.toggleBlocks(newIndex);
        this.toggleBtns(newIndex);
    }


    /**
     * Toggles the active state on the buttons.
     * 
     * @private
     * @return void
     * @param newIndex The index of the new block.
     */
    private toggleBtns(newIndex: number): void {
        this.btns.forEach((btn, index) => {
            const label = btn.getAttribute('data-label') as string;
            if(index === newIndex) {
                history.pushState('', '', `?${insertParam(this.id, label)}#${this.id}`);
                btn.classList.add('c-content-switcher__btn--is-active');
            } else {
                btn.classList.remove('c-content-switcher__btn--is-active');
            }
        });
    }


    /**
     * Toggles the currently visible block.
     * 
     * @private
     * @return void
     * @param newIndex The index of the new block.
     */
    private toggleBlocks(newIndex: number): void {
        this.blocks.forEach((block, index) => {
            if(index === newIndex) {
                block.classList.add('c-content-switcher__block--is-active');
            } else {
                block.classList.remove('c-content-switcher__block--is-active');
            }
        });
    }
}
